export function formatPhoneNumber(value: string): string {
  let digits = value.replace(/\D/g, '');
  
  // Remove leading 1 (country code not allowed)
  if (digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  
  // Limit to 10 digits
  digits = digits.slice(0, 10);

  const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (!match) return value;

  const [, area, prefix, line] = match;

  if (digits.length < 4) return area;
  if (digits.length < 7) return `(${area}) ${prefix}`;
  return `(${area}) ${prefix}-${line}`;
}